module.exports = __webpack_public_path__ + "static/media/right-bracket.0a660e96.svg";